import React from 'react';
import BookingFlow from './components/BookingFlow/BookingFlow';
import CustomerCancel from './components/CustomerCancel/CustomerCancel';
import CustomerPortal from './components/CustomerPortal/CustomerPortal';
import { AdminProvider } from './context/AdminContext';
import { AuthProvider } from './context/AuthContext';

const App: React.FC = () => {
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  const isWidget = params.get('widget') === 'true';

  // Widget Mode: Nur BookingFlow, volle Höhe
  if (isWidget) {
    return (
      <div style={{ width: '100vw', height: '100vh', margin: 0, padding: 0, overflow: 'hidden' }}>
        <AuthProvider>
          <AdminProvider>
            <BookingFlow />
          </AdminProvider>
        </AuthProvider>
      </div>
    );
  }

  if (path === '/stornieren' || path === '/cancel') {
    return <CustomerCancel />;
  }

  if (path === '/portal' || path === '/mein-konto') {
    return <CustomerPortal />;
  }

  return (
    <AuthProvider>
      <AdminProvider>
        <BookingFlow />
      </AdminProvider>
    </AuthProvider>
  );
};

export default App;
    